module.exports = __webpack_public_path__ + "img/eye.a013984a.svg";